import React from 'react';
import Device from "./Device";
import {Drawer} from "antd";

export default ({height, show, onClose, children, ...props}) => {
  let placement = "right";

  if (Device.xs && !height)
    height = "auto"

  return <Drawer closable={true}
                 height={height}
                 onClose={onClose}
                 placement={placement}
                 visible={show}
                 bodyStyle={{padding: 0}}
                {...props}>
    {children}
  </Drawer>
}